<smt-modal [(isActive)]="confirmModalActive"  [allowDropDownOverflow]="true" [disableFooter]="false" [disableHeader]="true"
    (acceptEvent)="onRemoveCostCenterClick()" (rejectEvent)="confirmModalActive = false"
    acceptText="Remove" acceptCssClass="button primary" rejectText="Cancel" rejectCssClass="button cancel">
    <div role="body">
        Please confirm permanent removal of record.
    </div>
</smt-modal>
<smt-modal [(isActive)]="confirmUnsavedModalActive" [disableFooter]="false" [disableHeader]="true"
    (acceptEvent)="unsavedFunction()" (rejectEvent)="confirmUnsavedModalActive = false"
    acceptText="Yes" acceptCssClass="button primary" rejectText="No" rejectCssClass="button cancel">
    <div role="body">
        There are unsaved changes that will be lost by continuing.  Are you sure?
    </div>
</smt-modal>
<smt-modal [(isActive)]="confirmZeroCostCenterSlots" [disableFooter]="false" [disableHeader]="true"
    (acceptEvent)="this.confirmZeroCostCenterSlots = false" (rejectEvent)="this.confirmZeroCostCenterSlots = false"
    acceptText="Ok" acceptCssClass="button primary">
    <div role="body">
      Please contact your Huron representative to add more cost centers.
    </div>
</smt-modal>
<smt-modal [(isActive)]="confirmCopyModalActive" [disableFooter]="false" [disableHeader]="true"
   (acceptEvent)="confirmCopyModalActive = false"    (rejectEvent)="confirmCopyModalActive = false"
    acceptText="Ok" acceptCssClass="button primary">
    <div role="body">
        Your cost center has been copied successfully.
    </div>
</smt-modal>
<div class="page-header-outer">
    <div class="page-header" >
      <div>
        <h1>Cost Center</h1>

        <div class="remaing-cost-centers-msg">{{ costCenterSlots > 0 ? 'You have ' + costCenterSlots + ' cost centers remaining.' : 'You have 0 cost centers left to add.'}}</div>
      </div>
      <div class="controls">
        <button [disabled]="!addButtonEnabled" (click)="onAddCostCenterClick()"><span class="icon-plus"></span> Add New</button>
      </div>
    </div>
</div>
<div class="content-inner">
    <div class="admin-main" [ngClass]="{'loading': initialLoading || mobileLoading }" >
        <div>
            <div class="admin-list" [ngClass]="{'loading': adminListLoading }"
                infinite-scroll
                [infiniteScrollDistance]="scrollDistance"
                [infiniteScrollThrottle]="scrollThrottle"
                [fromRoot]="false"
                [scrollWindow]="false"
                [infiniteScrollContainer]="scrollSelector"
                (scrolled)="onScrollDown()">
                <div class="filter-sort">
                    <div class="filter">
                        <input class="magic-filter compact" (keyup)="onSearchKey($event)" [(ngModel)]="searchText" name="SearchKey" type="text" placeholder="Search by Name">
                    </div>
                    <div class="sort">
                        <label>Sort</label>
                        <select class="compact" (change)="onSortTypesDropDownChanged($event)" [(ngModel)]="selectedFilter" name="SortList">
                            <option *ngFor='let type of sortTypes' [value]="type" (change)="setSelectedFilter($event)">
                                {{type}}
                            </option>
                        </select>
                        <a class="arrow compact" (click)="onChangeSortOrder()"
                            [ngClass]="sortAscending ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold'"></a>
                    </div>
                </div>
                <ul class="adminListScroll" >
                    <li *ngFor="let costCenter of costCenters" [value]="costCenter.id" (click)="onSelection(costCenter)"
                        [ngClass]="{'active': selection != undefined && selection != null && costCenter.id == selection.id } ">
                            <ul class="flags">
                                <li class="active">
                                    <div class="added">
                                        <span class="active">
                                            <div *ngIf="costCenter.mostRecent">
                                                <span class="icon-plus"></span> New
                                            </div>
                                        </span>
                                    </div>
                                    <div *ngIf="costCenter.inactiveDate == null">
                                        <span class="icon-radio-checked"></span> Active
                                    </div>
                                    <div *ngIf="costCenter.inactiveDate != null">
                                        <span class="icon-radio-unchecked"></span> Inactive
                                    </div>
                                </li>
                            </ul>
                            <div class="title">{{ costCenter.name }}</div>
                            <ul class="details">
                                <li class="modified">
                                    <span class="label">Number</span>
                                    <span class="value">{{ costCenter.number }}</span>
                                </li>
                                <li class="modified">
                                    <span class="label">Facility Name</span>
                                    <span class="value">{{ costCenter.facility.name }}</span>
                                </li>
                                <li class="modified">
                                    <span class="label">Facility Acronym</span>
                                    <span class="value">{{ costCenter.facility.acronym }}</span>
                                </li>
                                <li class="modified">
                                    <span class="label">Last Modified</span>
                                    <span class="value">{{ costCenter.modifiedDate == null ? "&nbsp;" : ( costCenter.modifiedDate + "Z" | date: 'M/dd/yy h:mm a') }}</span>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="admin-action-window" [ngClass]="{ 'loading': adminActionLoading }">
                    <div class="admin-action stacked-tabs active" id="edit" [ngClass]="{ 'active': showAdminActionWindow }" *ngIf="selection">
                        <div class="header">
                            <div class="title">
                                {{ adminActionLabelText }}
                                <button class="compact" *ngIf="addButtonEnabled && selection.id > 0" (click)="onCopyCostCenter()">{{ adminActionButton2LabelText }}</button>                          
                                <button class="primary compact" [disabled]="!deleteButtonEnabled" (click)="confirmModalActive = true"><span class="icon-trash btn-Icon"></span>{{ adminActionButton1LabelText }}</button>
                                <a class="close" (click)="onCancel()"><span class="icon-cross"></span></a>
                                </div>
                            <ul class="tabs">
                                <li [ngClass]="{ 'active': generalTabActive }" (click)="setActiveTab(generalTabName)">
                                    <a>General</a>
                                </li>
                                <li *ngIf="selection && selection.id" [ngClass]="{ 'active': detailsTabActive }" (click)="setActiveTab(detailsTabName)">
                                    <a>Details</a>
                                </li>                                
                                <li *ngIf="selection && shouldDisplayStaffingTab" [ngClass]="{ 'active': staffingGridTabActive }" (click)="setActiveTab(staffingGridTabName)">
                                    <a>Staffing Grid</a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <form #costCenterEditForm="ngForm" (ngSubmit)="onSave()">
                                <ng-container>
                                    <section>
                                        <div class="body" *ngIf="generalTabActive">
                                            <smt-general-tab [(costCenter)]="selection" [hasCostCenterSlots]='costCenterSlots > 0'
                                                 [readOnly]="!hasPermission" (saveClicked)='onSaveClick()' [currentUser]='currentUser'></smt-general-tab>
                                        </div>
                                        <div class="body" *ngIf="detailsTabActive">
                                            <smt-details-tab [(costCenter)]="selection" [readOnly]="!hasPermission"></smt-details-tab>
                                        </div>
                                        <div class="body" *ngIf="staffingGridTabActive">
                                            <smt-staffing-grid [(costCenter)]="selection"  [(isStaffingGridSaved)]='isCostCenterSaved' [readOnly]="disableStaffinGrid"></smt-staffing-grid>
                                        </div>
                                        <div class="footer">
                                            <div>
                                                <label class="errormsg">{{ getErrorMessage() }}</label>
                                                <label class="warningmsg">{{ getWarningMessage() }}</label>
                                            </div>
                                            <div class="buttons">
                                                <button class="primary" type="submit" [disabled]="!enableSaveButton()">
                                                    <span class="icon-plus"></span> Save</button>
                                                <button class="cancel" type="button" (click)="onCancel()" [disabled]="saveLoading">
                                                    <span class="icon-cancel"></span> Cancel</button>
                                            </div>
                                        </div>
                                    </section>
                                </ng-container>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
